export const MAP_COLOR_PRESETS = [
  '#6AA6FF',
  '#81B5EB',
  '#5989E9',
  '#7879F1',
  '#09007F',
  '#3E556D',
  '#92C72B',
  '#008081',
  '#297F50',
  '#7F0000',
  '#FF3B00',
  '#CD5E1B',
  '#FF9A01',
  '#CBAB80',
  '#B48484',
  '#EC77EB',
  '#CD65CC',
  '#D56587',
  '#7E25DF',
  '#535353'
];

export const SECTION_IDS = {
  CONTACT: 'contact-details',
  ACCESS: 'access',
  MORE_OPTIONS: 'more-options'
} as const;

export const sectionTabs = [
  { id: SECTION_IDS.CONTACT, label: 'Contact details' },
  { id: SECTION_IDS.ACCESS, label: 'Access' },
  { id: SECTION_IDS.MORE_OPTIONS, label: 'More options (optional)' }
] as const;

export const errorDefaultState = {
  phoneError: null,
  firstNameError: null,
  emailError: null
} as const;
